import Produto from "model/administracao/cadastro/produto/Produto";
import EstagioOP from "./EstagioOP";
import LoteComponenteOP from "./LoteComponenteOP";
import { generateKey } from "utils/generateKey";

export default class ComponenteOP {
    id: number;
    key: string;
    estagioOP: EstagioOP | null;
    componente: Produto | null;
    sequencial: number;
    qtPrevista: number;
    qtUtilizada: number;
    acerto: string;
    observacao: string;
    lotes: LoteComponenteOP[];

    constructor(
        id: number = 0,
        estagioOP: EstagioOP | null = null,
        componente: Produto | null = null,
        sequencial: number = 0,
        qtPrevista: number = 0,
        qtUtilizada: number = 0,
        acerto: string = "N",
        observacao: string = "",
        lotes: LoteComponenteOP[] = []
    ) {
        this.id = id;
        this.key = generateKey();
        this.estagioOP = estagioOP;
        this.componente = componente;
        this.sequencial = sequencial;
        this.qtPrevista = qtPrevista;
        this.qtUtilizada = qtUtilizada;
        this.acerto = acerto;
        this.observacao = observacao;
        this.lotes = lotes;
    }

}